import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, SFNotification } from 'utils/types';
import css from './Footer.scss';
import { Dropdown } from 'semantic-ui-react';
import CancelModal from './CancelModal';
import moment from 'moment';
import 'moment-timezone';

export default class Footer extends React.Component {

  constructor() {
    super();
    this.state = { isConfirmDialogOpen: false };
  }

  onDropdownItemClicked(e, data) {
    switch ( data.value ) {
      case "cancel":
        this.onCancelAppointmentClicked(data);
        break;
      default:
        break;
    }
  }

  onCancelAppointmentClicked() {
    this.setState({isConfirmDialogOpen: true});
  }

  closeModal() {
    this.setState({isConfirmDialogOpen: false});
  }

  get cancelModal() {
    // Re-mounts to regenerate state
    return this.state.isConfirmDialogOpen
      ? <CancelModal
          appointmentId={this.props.appointmentId}
          ownerName={this.props.ownerName}
          startDate={moment(this.props.startDate).tz(this.props.timeZone)}
          recurring={this.props.recurring}
          notification={this.props.notification}
          open={this.state.isConfirmDialogOpen}
          onClose={this.closeModal.bind(this)}
          onSuccess={() => {
            this.props.notification.success("Appointment successfully canceled");
            this.props.getAppointments();
          }}
        />
      : null;
  }

  render() {
    return (
      <div className={css['footer']}>
        <div className={css['dropdown-container']}>
          <Dropdown
            text=' '
            selectOnBlur={false}
            selectOnNavigation={false}
            icon="ellipsis horizontal"
            upward
            className={css['item-dropdown']}
            onChange={this.onDropdownItemClicked.bind(this)}
            options={[{ key: "cancel", text: "Cancel appointment", value: "cancel" }]}
            value=""
          />
        </div>
        {this.cancelModal}
      </div>
    );
  }
}

Footer.defaultProps = {
  timeZone: "America/New_York"
};

Footer.propTypes = {
  appointmentId: SFEntityID.isRequired,
  notification: SFNotification.isRequired,
  timeZone: PropTypes.string,
  ownerName: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  getAppointments: PropTypes.func.isRequired,
  recurring: PropTypes.bool
};
